import Decimal from 'decimal.js';

export const matchAmountsWithPrecision = (firstAmount: string, secondAmount: string, precision = 2): boolean => {
  if (!firstAmount || !secondAmount) {
    return false;
  }

  const firstRounded = new Decimal(firstAmount).toDecimalPlaces(precision, Decimal.ROUND_DOWN);
  const secondRounded = new Decimal(secondAmount).toDecimalPlaces(precision, Decimal.ROUND_DOWN);

  return firstRounded.equals(secondRounded);
};
